var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',{attrs:{"path":_vm.localeKey,"tag":"p"},scopedSlots:_vm._u([{key:"url",fn:function(){return [_c('a',{attrs:{"href":_vm.$t('url.rockestate_main'),"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('url.rockestate_main'))+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }